import {
    pauseAudio as pauseQuestionAudio,
    activated as questionAudioActivated,
    resetAudioPlayback as resetQuestionAudioPlayback,
} from './question-audio';

let audioPlaying = false;
let currentlyPlayingAudio;
const mediaPlayer = document.getElementById('media-player');
const audioPlayer = document.getElementById('audio-player');
const audioButtons = [...document.querySelectorAll('.audio-button:not(#question-audio-button)')];

if (audioPlayer) {
    audioPlayer.addEventListener('ended', () => {
        showPlayButton();
        audioPlaying = false;
        currentlyPlayingAudio = '';
    });
}

audioButtons.forEach((audioButton) => {
    audioButton.addEventListener('click', () => {
        pauseOtherMedia();
        togglePlayPause(audioButton);
    });
});

function togglePlayPause(audioButton) {
    if (audioPlaying) {
        pauseAudio();

        if (currentlyPlayingAudio === audioButton) {
            return;
        }
    }

    currentlyPlayingAudio = audioButton;

    loadAudio(audioButton.dataset.audio);
    playAudio();
}

function loadAudio(newSource) {
    let currentSource;

    try {
        currentSource = new URL(audioPlayer.src).pathname;
    } catch (error) {}

    if (currentSource !== newSource) {
        audioPlayer.src = newSource;
        audioPlayer.load();
    }
}

function playAudio() {
    audioPlayer.play();
    audioPlaying = true;
    showPauseButton(currentlyPlayingAudio);
}

function pauseAudio() {
    audioPlayer.pause();
    audioPlaying = false;
    showPlayButton();
}

function showPlayButton() {
    if (currentlyPlayingAudio) {
        currentlyPlayingAudio.classList.add('paused');
        currentlyPlayingAudio.classList.remove('playing');
    }
}

function showPauseButton() {
    if (currentlyPlayingAudio) {
        currentlyPlayingAudio.classList.add('playing');
        currentlyPlayingAudio.classList.remove('paused');
    }
}

function pauseOtherMedia() {
    if (mediaPlayer) {
        if (mediaPlayer.pause) {
            mediaPlayer.pause();
        } else if (mediaPlayer.player.pause) {
            mediaPlayer.player.pause();
        }
    }

    if (questionAudioActivated) {
        pauseQuestionAudio();
        resetQuestionAudioPlayback();
    }
}

export function updateAnswerButtonAudio(answerButtonContent) {
    const nextQuestionAudioButton = document.getElementById('next-question-audio-button');
    const checkAnswerAudioButton = document.getElementById('check-answer-audio-button');
    const submitQuizAudioButton = document.getElementById('submit-quiz-audio-button');

    if (answerButtonContent.parentElement.classList.contains('d-none')) {
        hideAllAnswerButtonAudio();
        return;
    }

    switch (answerButtonContent.dataset.buttonText) {
        case 'Next Question':
            hideAllAnswerButtonAudio();
            nextQuestionAudioButton?.classList.remove('d-none');
            break;
        case 'Check Answer':
            hideAllAnswerButtonAudio();
            checkAnswerAudioButton?.classList.remove('d-none');
            break;
        case 'Submit Quiz':
            hideAllAnswerButtonAudio();
            submitQuizAudioButton?.classList.remove('d-none');
            break;
    }

    function hideAllAnswerButtonAudio() {
        nextQuestionAudioButton?.classList.add('d-none');
        checkAnswerAudioButton?.classList.add('d-none');
        submitQuizAudioButton?.classList.add('d-none');
    }
}
